module.exports = __webpack_public_path__ + "img/20_128.876fd9b1.png";